import {ITheme} from 'contexts/ThemeContext';
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  minSize,
} from 'rn-responsive-styles';

export default ({colors, typography}: ITheme) =>
  CreateResponsiveStyle(
    {
      dayNavigationContainerStyle: {
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: 25,
        width: 400,
        height: 40,
      },
      dayNavigationTitleWrapper: {
        marginLeft: 16,
        marginRight: 10,
      },
      dayNavigationTitleStyle: {
        width: 370,
        fontSize: 30,
        lineHeight: 40,
        color: colors.primaryTextColor,
        ...typography.interMedium,
      },
      buttonContainerStyle: {
        flexDirection: 'row',
        alignItems: 'center',
      },
      buttonStyle: {
        justifyContent: 'center',
        alignItems: 'center',
        marginHorizontal: 3,
        width: 33,
        height: 33,
        backgroundColor: colors.white,
        borderRadius: 8,
        shadowColor: colors.black,
        shadowOffset: {
          width: 0,
          height: 4,
        },
        shadowOpacity: 0.13,
        shadowRadius: 2.62,

        elevation: 4,
      },
      imageStyle: {
        width: 6.5,
        height: 11,
        tintColor: colors.black,
      },
    },
    {
      [minSize(DEVICE_SIZES.SMALL_DEVICE)]: {},
    },
  )();
